import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import CardHeader from "../../Common/CardHeader/CardHeader";
import search from "../../assets/images/search-lg.svg";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import { userCategoriesList } from "../../../redux/user/action";
import DeleteCategory from "./DeleteCategory";
import { deleteOneCategory } from "../../../redux/categories/action";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";

const CategoriesList = () => {
  const [params, setParams] = useState({
    search_key: "",
    page: 1,
    type: 1,
  });
  const dispatch = useDispatch();
  const [currentComponent, setCurrentComponent] = useState({});
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [modals, setModals] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [isloading, setIsLoading] = useState(true);

  const categoryList = useSelector(
    (state) => state?.reusableSlice?.categoryList
  );

  useEffect(() => {
    dispatch(userCategoriesList(params))
      .then((res) => {
        if (res.status) {
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((e) => setIsLoading(false));
  }, [params, dispatch]);

  const addComponent = () => {
    navigate("/category/add");
  };

  const updateComponent = (id) => {
    navigate(`/udpatecategory/${id}`);
  };

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteOneCategory(currentComponent?.id));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  return (
    <>
      {isloading ? (
        <FullScreenLoader />
      ) : (
        <div className="py-3">
          <CardHeader
            headerTitle="Category List"
            params={params}
            setParams={setParams}
            addmodel={addComponent}
            search={search}
            setOpenFilter={setOpenFilter}
            modals={modals}
            setModals={setModals}
          />

          <CardBody className="table-sec px-3">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Title</th>
                  <th scope="col">Ar Title</th>
                  <th scope="col">Position</th>
                  <th scope="col">Status</th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {categoryList?.categories?.length > 0 ? (
                  categoryList?.categories?.map((item, index) => (
                    <tr key={index}>
                      <td> {index + 1 + (params?.page - 1) * 10}</td>
                      <td>{`${item?.title}`} </td>
                      <td>{item?.ar_title} </td>
                      <td>{item?.position} </td>
                      <td>
                        {item?.status == 1
                          ? "Active"
                          : item?.status == 2
                          ? "Inactive"
                          : ""}{" "}
                      </td>
                      <td>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ columnGap: "10px" }}
                        >
                          <button
                            className="border-button"
                            onClick={() => updateComponent(item?.id)}
                          >
                            <span>Update</span>
                          </button>
                          <button
                            className="background-button"
                            onClick={() => {
                              setModal(true);
                              setCurrentComponent(item);
                            }}
                          >
                            <span>Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Categories Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </CardBody>
          <CommonPagination
            params={params}
            setParams={setParams}
            pagination_meta={categoryList?.pagination_meta}
          />

          <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
            <DeleteCategory
              modalTitle={"Category"}
              setModal={setModal}
              currentComponent={currentComponent}
              deleteComponent={deleteComponent}
            ></DeleteCategory>
          </Modal>
        </div>
      )}
    </>
  );
};

export default CategoriesList;
